import React, { Component } from "react";
import _ from "lodash";
import CallToAction from "./call-to-action";

export default class PostEntry extends Component {
  render() {
    let bonuses = [];

    _.each(this.props.acceptedInvites, (invite) => {
      bonuses = bonuses.concat(invite.bonuses);
    });

    let callsToAction = [];

    _.each(this.props.acceptedInvites, (postEntry, idx) => {
      callsToAction.push(
        <CallToAction
          key={postEntry.id}
          postEntry={postEntry}
          campaign={this.props.campaign}
          bonuses={bonuses}
        />,
      );
    });

    // post-entry is hidden until after signup
    return (
      <div className="stage post-entry hide">
        <p>Thank You For Entering {this.props.campaign.name}</p>
        {callsToAction}
      </div>
    );
  }
}
